import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components/core/Button';

import './UnitListItem.scss';

export function UnitListItem({ className, children, onClick }) {
	return (
		<Fragment>
			{!onClick ? (
				<div
					className={classnames(
						className,
						'atomic-unit-list-item',
						'unit-list-item',
					)}
				>
					{children}
				</div>
			) : (
				<Button
					pink
					primary={false}
					className={classnames(
						className,
						'atomic-unit-list-item',
						'unit-list-item',
					)}
					onClick={onClick}
				>
					{children}
				</Button>
			)}
		</Fragment>
	);
}

UnitListItem.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	onClick: PropTypes.func,
};

export default UnitListItem;

